import { apiGet, apiPost, hasPermission } from './apiWrapper';
import { getTranslate } from 'react-localize-redux';
import { isNullOrUndefined } from './storeFunctions';
import { PORTFOLIO_TYPES } from '../components/monitoring/monitoringConstants';

const getAddToPortfolioPopupData = "GET_ADD_TO_PORTFOLIO_POPUP_DATA";
const portfolioErr = "PORTFOLIO_ERR";

const initialState = { items: [], isLoading: false, addToPortfolioPopupData: null, message: '', messageType: '' };

//action creator for redux
export const monitoringActions = {
    getAddToPortfolioPopupData: (entityId, isCompany, primaryAttr) => async (dispatch, getState) =>
        getAddToPortfolioPopup(dispatch, getState, entityId, isCompany, primaryAttr),
    subjectFromPortfolioRemoved: (id, entityId, isCompany, primaryAttr) => async (dispatch, getState) =>
        removeSubjectFromPortfolio(dispatch, getState, id, entityId, isCompany, primaryAttr),
    subjectToPortfolioAdded: (entityId, portfolioId, label, subjectName, companyId, dob, isCompany, primaryAttr) => async (dispatch, getState) =>
        addSubjectToPortfolio(dispatch, getState, entityId, portfolioId, label, subjectName, companyId, dob, isCompany, primaryAttr),
    portfolioCreated: (entityId, label, subjectName, companyId, dob, isCompany, primaryAttr, newName) => async (dispatch, getState) =>
        createPortfolio(dispatch, getState, entityId, label, subjectName, companyId, dob, isCompany, primaryAttr, newName),
    createEmptyPortfolio: (name, type, callback) => async (dispatch) =>
        createEmptyPortfolio(dispatch, name, type, callback),
    deletePortfolio: (id, callback, callbackError) => async (dispatch) =>
        deletePortfolio(dispatch, id, callback, callbackError)
};

// store reducer
export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getAddToPortfolioPopupData:
            return { ...state, addToPortfolioPopupData: action.data, message: action.message, messageType: action.messageType, messageData: action.messageData };
        case portfolioErr:
            return { ...state, message: action.exception || "Monitoring.Add.Error", messageType: "error", messageData: action.exceptionData };
        default:
            return state;
    }
}

function getAddToPortfolioPopup(dispatch, getState, entityId, isCompany, primaryAttr, message, messageType, messageData) {
    apiGet(`${window.babylonApiUrl}/api/portfolio/get-add-to-portfolio-popup-data`,
        { entityId, isCompany, marketAttribute: primaryAttr },
        (s) => {
            if (s.data.isSuccess)
                dispatch({ type: getAddToPortfolioPopupData, data: s.data, message, messageType, messageData });
            else
                dispatch({ type: portfolioErr, exception: s.data.exception, exceptionData: isNullOrUndefined(s.data.exceptionData) ? undefined : s.data.exceptionData });
        },
        (_) => dispatch({ type: portfolioErr })
    );
}

function removeSubjectFromPortfolio(dispatch, getState, id, entityId, isCompany, primaryAttr) {
    var ids = id.split('|');
    var subjects = new Array(1);
    subjects[0] = Number(ids[1]);
    apiPost(`${window.babylonApiUrl}/api/portfolio/${ids[0]}/subjects/remove`,
        { id: ids[0] },
        subjects,
        s => {
            if (s.data.isSuccess)
                getAddToPortfolioPopup(dispatch, getState, entityId, isCompany, primaryAttr, 'Monitoring.Add.RemovedOk', 'success', null);
            else
                dispatch({ type: portfolioErr, exception: s.data.exception, exceptionData: isNullOrUndefined(s.data.exceptionData) ? undefined : s.data.exceptionData });
        },
        _ => dispatch({ type: portfolioErr })
    );
}

function addSubjectToPortfolio(dispatch, getState, entityId, portfolioId, label, subjectName, companyId, dob, isCompany, primaryAttr, newPortfolio = false) {
    var subjects = new Array(1);
    subjects[0] = { entityId, name: subjectName, label, companyId, birthDate: dob }
    apiPost(`${window.babylonApiUrl}/api/portfolio/${portfolioId}/subjects/add`,
        { id: portfolioId },
        { subjects },
        s => {
            if (s.data.isSuccess)
                getAddToPortfolioPopup(dispatch, getState, entityId, isCompany, primaryAttr, prepareMessage(s.data.value.addedItems != 1, newPortfolio, portfolioId, s.data.value, getState), s.data.value.addedItems === 1 ? 'success' : 'warning', prepareMessageData(s.data.value, portfolioId, getState));
            else
                dispatch({ type: portfolioErr, exception: s.data.exception, exceptionData: isNullOrUndefined(s.data.exceptionData) ? undefined : s.data.exceptionData });
        },
        _ => dispatch({ type: portfolioErr })
    );
}

function prepareMessage(isDuplicate, isNewPortfolio) {
    if (isDuplicate) return 'Monitoring.Add.Duplicate';
    if (hasPermission(null, 'MonitoringSubjects') || hasPermission(null, 'MonitoringPersons')) {
        if (isNewPortfolio) return 'Monitoring.Add.CreatePortfolio.HasPermissions.AddedOk';
        return 'Monitoring.Add.AddedOk.HasPermissions';
    } else {
        if (isNewPortfolio) return 'Monitoring.Add.CreatePortfolio.AddedOk';
        return 'Monitoring.Add.AddedOk';
    }
}

function prepareMessageData(data, portfolioId, getState) {
    let activeText = data.isActive ? getTranslate(getState().localize)('Monitoring.Overview.Active') : getTranslate(getState().localize)('Monitoring.Overview.Inactive');

    let msgData = {
        PortfolioName: data.name,
        isActive: activeText,
        portfolioId: portfolioId
    }
    return msgData;
}

function createPortfolio(dispatch, getState, entityId, label, subjectName, companyId, dob, isCompany, primaryAttr, newName) {
    var portfolioType;
    if (isCompany)
        portfolioType = primaryAttr === 1 ? PORTFOLIO_TYPES.companyCz : PORTFOLIO_TYPES.companySk;
    else
        portfolioType = primaryAttr === 1 ? PORTFOLIO_TYPES.personCz : PORTFOLIO_TYPES.personSk;

    apiPost(`${window.babylonApiUrl}/api/portfolio/create`,
        null,
        { name: newName, type: portfolioType, isMonitored: true },
        (s) => {
            if (s.data.isSuccess)
                addSubjectToPortfolio(dispatch, getState, entityId, s.data.id, label, subjectName, companyId, dob, isCompany, primaryAttr, true);
            else
                dispatch({ type: portfolioErr, exception: s.data.exception, exceptionData: isNullOrUndefined(s.data.exceptionData) ? undefined : s.data.exceptionData });
        },
        (_) => dispatch({ type: portfolioErr })
    );
}

function createEmptyPortfolio(dispatch, name, type, callback) {
    apiPost(`${window.babylonApiUrl}/api/portfolio/create`,
        null,
        { name: name, type: type },
        s => callback(s),
        _ => dispatch({ type: portfolioErr })
    );
}

function deletePortfolio(dispatch, id, callback, callbackError) {
    apiPost(`${window.babylonApiUrl}/api/portfolio/${id}/remove`,
        { id },
        null,
        s => callback(s),
        e => {
            dispatch({ type: portfolioErr });
            callbackError(e);
        }
    );
}